import React from "react";
import { connect } from "react-redux";
import { Formik } from "formik";

import { FormCollapsible, Select, SubmitButton, TextInput } from "components/forms";
import { createEntityDocument, editEntityDocument, fetchFunderEntities, hideModal } from "actions";
import { Form } from "react-bootstrap";
import {
  activeFunderEntityIdSelector,
  activeFunderEntitySelector,
  activeFunderSelector,
  activeEntityDocumentIdSelector,
} from "../../reducers";
import { makeChoices, partial, prepareModalMultipleSelect } from "../../utils";
import * as notifications from "../../notifications";
import { transactionTypeChoices } from "./constants";

const EntityDocumentForm = ({ ...props }) => {
  let initialValues = props.entityDocumentInfo || {};
  let [transactionType, setTransactionType] = React.useState();
  const handleTransactionTypeChange = selectedOptions => {
    if (selectedOptions) {
      const commaSeparatedValues = selectedOptions.map(o => o.value).join(",");
      setTransactionType(commaSeparatedValues);
    } else {
      setTransactionType(undefined);
    }
  };

  let transaction_type_initial = prepareModalMultipleSelect(
    "transaction_type",
    transactionTypeChoices,
    props.entityDocumentInfo,
  );

  return (
    <Formik
      enableReinitialize={false}
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        let entityDocumentId = props.entityDocumentInfo && props.entityDocumentInfo.id;
        const method = entityDocumentId
          ? partial(props.editEntityDocument, entityDocumentId)
          : props.createEntityDocument;

        values.funder_entity_id = props.activeFunderEntityId;
        values.transaction_type = transactionType;
        delete values.file; // File is saved through a different endpoint
        try {
          await method(values);
          await props.fetchFunderEntities(props.activeFunderId);
          notifications.success("Entity Document saved");
        } catch (error) {
          setErrors(error.response.data);
          notifications.error("Error saving Entity Document");
        }
      }}
    >
      {({ handleSubmit, values, setFieldValue }) => {
        return (
          <FormCollapsible
            onSubmit={handleSubmit}
            title={props.activeEntityDocumentId ? "Edit Entity Document" : "New Entity Document"}
          >
            <Form.Row>
              <Select label="Document Type" name="document_type" options={props.entityDocumentTypeChoices} />
              <TextInput label="Description" name="description" />
            </Form.Row>
            <SubmitButton innerRef={props.submitRef} style={{ display: "none" }} />
          </FormCollapsible>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = state => {
  const activeEntityDocumentId = activeEntityDocumentIdSelector(state);
  const activeFunderEntity = activeFunderEntitySelector(state);
  let entityDocumentInfo;
  if (activeEntityDocumentId && activeFunderEntity) {
    for (const entity_document of activeFunderEntity.entity_documents) {
      if (entity_document.id === activeEntityDocumentId) {
        entityDocumentInfo = entity_document;
        break;
      }
    }
  }

  const ENTITY_DOCUMENT_TYPES = [
    "IRS W-9",
    "Corporate Resolution",
    "Operating Agreement",
    "Bylaws",
    "Partnership Agreement",
    "Trust Agreement",
    "EIN Verification",
    "Certificate of Incumbency",
    "Sample Change Forms",
  ];
  const entityDocumentTypeChoices = makeChoices(ENTITY_DOCUMENT_TYPES);
  let funderInfo = activeFunderSelector(state);
  return {
    entityDocumentInfo,
    activeFunderId: funderInfo.id,
    activeFunderEntityId: activeFunderEntityIdSelector(state),
    activeEntityDocumentId: activeEntityDocumentId,
    entityDocumentTypeChoices,
  };
};

export default connect(mapStateToProps, {
  fetchFunderEntities,
  editEntityDocument,
  createEntityDocument,
  hideModal,
})(EntityDocumentForm);
